const getModuleState = state => state.axes

export const isFetching = state => getModuleState(state).isLoading
export const hasFetchError = state => getModuleState(state).hasError
export const getAxes = state => getModuleState(state).axes
